// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_i77Gr","red":"index_red_78xRx","green":"index_green_vGodU","price":"index_price_F5NxA"};